import { shallowEqual, useSelector } from 'react-redux';
import { store } from '@/app/store';

/**
 * Call Model Selectors + Hooks
 *
 * All selectors and React hooks for callkitDataSlice live here.
 * callkitDataSlice.js contains only the slice definition, actions, and reducer export.
 */

// ─── Store-direct helpers (non-React, use sparingly) ──────────────────────────

export const getCallkitState = key => store.getState().callkitData?.[key];

export const getCallkitSnapshot = () => store.getState().callkitData;

// ─── React hooks ─────────────────────────────────────────────────────────────

/**
 * Subscribe to multiple callkitData keys at once.
 * Re-renders only when one of the requested keys changes (shallowEqual).
 *
 * Usage:
 *   const { callScreenStatus, callUIState } = useCallkitDataKeys(['callScreenStatus', 'callUIState'])
 */
export function useCallkitDataKeys(keys) {
   return useSelector(
      state =>
         keys.reduce((acc, key) => {
            acc[key] = state.callkitData[key];
            return acc;
         }, {}),
      shallowEqual,
   );
}

/**
 * Subscribe to a single callkitData key.
 * For simple single-key reads without object allocation.
 */
export function useCallkitData(key) {
   return useSelector(state => state.callkitData?.[key]);
}
